(function() {
  angular.module('registration')
  .controller('verifyEmailController', ['$state', 'User','$stateParams',
  function($state, User,$stateParams) {
    User.verifyEmail({'id': $stateParams.id, 'guid':$stateParams.guid}, function(data) {
      $state.go('root',{allParams : {showConfirmationMessage: " Your email address has been verified. "}});
    },(error)=>{
      if (error === 'linkNoLongerValid') {
        $state.go('root',{allParams : {
          showConfirmationMessage: "The email verification link is no longer valid.", type: 'warning'}
        });
      } else if (error === 'guidNotFound') {
        $state.go('root',{allParams : {
          showConfirmationMessage: "The email verification link is invalid.", type: 'danger'}
          });
      } else {
        $state.go('root');
      }
    });
  }]);
})();
